module.exports = __webpack_public_path__ + "img/vn.6b3aef51.svg";